/* eslint-disable react/require-default-props */
import React from 'react';
import cn from 'classnames';

import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import useTip from 'hooks/useTip.hook';
import { useTheme } from 'providers/Theme.provider';

import ScheduledBookingDescription from 'clientProfile/components/scheduledBooking/ScheduledBookingDescription';

import CN from './ScheduledBookingContainer.module.scss';

const ScheduledBookingContainer = (props) => {
  const { isDarkMode } = useTheme();
  const { val: isFoldOpen, tip: toggleFold } = useTip(false);

  return (
    <div
      data-bem="ScheduledBookingContainer"
      className={cn({
        sb: true,
        [CN.component]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      <header className="bgr" />

      <div className={CN.flex}>
        <h3 data-bem="ScheduledBookingContainer__title">Scheduled Bookings</h3>

        <Button tag="ScheduledBookingContainer__button" className={CN.button} onClick={toggleFold} variant="secondary">
          <div className={CN.toggleButtonContainer}>
            <span className={CN.underline}>What's included</span>
            <Icon
              tag="ScheduledBookingContainer__arrow"
              variant="arrowFoldoutPurple"
              selected={!isFoldOpen}
              unselected={isFoldOpen}
              width="lg"
            />
          </div>
        </Button>
      </div>

      {isFoldOpen && (
        <div data-bem="ScheduledBookingContainer__fold" className={CN.historyFold}>
          <span className={CN.dot}>
            Shows all future bookings in active state (inc waitlist, deleted stylist, no-show and cancelled)
          </span>
          <span className={CN.dot}>Excludes deleted bookings</span>
          <span className={CN.dot}>Shows additional booking info:</span>
          <ul className={CN.list}>
            <li className={CN.item}>- Deposit amount</li>
            <li className={CN.item}>- SMS sent and client replies</li>
            <li className={CN.item}>- Booking notes</li>
          </ul>
        </div>
      )}

      {props.data &&
        props.data.map((item) => (
          <ScheduledBookingDescription
            key={item.id}
            appointment={item}
            onScheduledAppointmentClick={props.onScheduledAppointmentClick}
            smsRemindersOn={props.smsRemindersOn}
          />
        ))}
    </div>
  );
};

export default ScheduledBookingContainer;
